import { Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import { selectSubjectPerformedInsUpd } from "../../../../redux/curriculum/subjectPerformedInsUpdSlice";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../../../redux/object/objectCacheSlice";
import { ObjectTarget } from "../../../../app/permissions";
import dayjs from "dayjs";

export function SubjectPerformedInsUpdReview() {
    const insUpd = useSelector(selectSubjectPerformedInsUpd);
    const sp = insUpd.subjectPerformed;

    const objectCacheState = useSelector(selectObjectCache);
    const dispatch = useAppDispatch();

    const classroom = getOrRetrieveNamedObject(dispatch, objectCacheState, ObjectTarget.CLASSROOM, `${sp.classroomId}`);
    const subject = getOrRetrieveNamedObject(dispatch, objectCacheState, ObjectTarget.SUBJECT, `${sp.subjectId}`);

    const row = (label: string, value: React.ReactNode) => (
        <>
            <Grid size={4} sx={{ textAlign: "right" }}>
                <Typography variant="subtitle2" color="text.secondary">{label}:</Typography>
            </Grid>
            <Grid size={8}>
                <Typography sx={{ color: "darkblue" }}>{value}</Typography>
            </Grid>
        </>
    );

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão da Aula
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2} sx={{ mt: 1 }}>
            {row("Sala", classroom?.display || sp.classroomId)}
            {row("Disciplina", subject?.display || sp.subjectId)}
            {row("Início", sp.startedAt ? dayjs(sp.startedAt).format('DD/MM/YYYY HH:mm') : "-")}
            {row("Fim", sp.endedAt ? dayjs(sp.endedAt).format('DD/MM/YYYY HH:mm') : "-")}
            {row("Horas Realizadas", sp.hoursPerformed != null ? `${sp.hoursPerformed}h` : "-")}
        </Grid>
    </>;
}
